(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('SitebarTypeAService', [
        '$http',
        '$q',
        function($http, $q) {
                this.getDefaultOptions = function() {
                    return {
                        insertionId: '',
                        creativeWidth: '300',
                        creativeHeight: '600',
                        showCloseCounter: '1',
                        closeCounter: 3,
                        closeActionTime: 0,
                        closeStickyTime: 5,
                        customCss: '/*no_custom_css*/',
                        maxWidth: '100%',
                        borderHeight: 2,
                        borderBackgroundColor: '#ffffff',
                        textLabelText: '',
                        fontSize: 12,
                        backgroundColor: '#000000',
                        textLabelColor: '#ffffff',
                        insertionCustomHtml: '',
                        expandHtml: '',
                        hardcodedClickout: '0',
                        rawJsAppendix: '',
                        expandable: '0',
                        expandedOnStart: '0',
                        startExpandedTime: 0,
                        expandedCreativeWidth: 450,
                        expandedCreativeHeight: 900,
                        clickURLExpanded: '',
                        expandTracking: []
                    };

                };

                this.generateContent = function(scope, InscreenCommonService, options){
                    var template = `try{
    var dspx = window.dspx || {};
    (function(dspx) {
        dspx.config  = dspx.config || {};

        dspx.config.debug= dspx.config.debug||false;
        dspx.config.siteId=[PID];
        dspx.config.insertionId= '[user_insertionId]';
        dspx.config.pageId= dspx.config.pageId||'1076383';
        dspx.config.customCss = '[user_customCss]';
        dspx.config.creativeId = [AID];
        dspx.config.sessionId= dspx.config.sessionId||Math.round(Math.random() * 100000);
        dspx.config.formatId= dspx.config.formatId||'sitebar';
        dspx.config.tagId= dspx.config.tagId||'dspx_'+dspx.config.formatId;
        dspx.config.smartTrackingUrl= dspx.config.smartTrackingUrl||'';

        dspx.config.creative= dspx.config.creative||{};
        dspx.config.creative.id= [AID];
        dspx.config.creative.url= '[CREATIVE_URL]';
        dspx.config.creative.cid= [CID];
        dspx.config.creative.width= '[user_creativeWidth]';
        dspx.config.creative.height= '[user_creativeHeight]';
        dspx.config.creative.geozip= "[GEOZIP]"; 
        dspx.config.viewCallback= function(){dspx_scroller_view_call();};
        dspx.config.creative.clickUrl= null;
        dspx.config.creative.clickUrlArray=[ '[CLICK_URL]' ];
        if([user_hardcodedClickout]){
           dspx.config.creative.clickUrlArray=[];
           dspx.config.creativeExtAsc=[ "[CLICK_TRACKING_URL]" ];
        }
        try {
            if (typeof js_pl_click_url != 'undefined') {
                js_pl_click_url=js_pl_click_url.replace('http:','https:');
                console.log("isset js_pl_click_url: "+js_pl_click_url);
                if (dspx.config.creativeExtAsc && Array.isArray(dspx.config.creativeExtAsc))
                  dspx.config.creativeExtAsc.push(js_pl_click_url);
                else 
                  dspx.config.creativeExtAsc=[js_pl_click_url];
            }
        } catch (e) {
            console.log("no js_pl_click_url!")
        };


        dspx.config.creative.oryginalClickUrl= dspx.config.creative.oryginalClickUrl||'';
        dspx.config.creative.clickTarget= dspx.config.creative.clickTarget || '_blank';
        dspx.config.creative.clickCountPixelUrl= dspx.config.creative.clickCountPixelUrl || '';
        dspx.config.creative.type= dspx.config.creative.type || 4;
        dspx.config.creative.agencyCode= dspx.config.creative.agencyCode || '';
        dspx.config.creative.expandHtml = "[user_expandHtml]";
        dspx.config.creative.expandable = '[user_expandable]';
        dspx.config.creative.expandedOnStart = '[user_expandedOnStart]';
        dspx.config.creative.startExpandedTime = '[user_startExpandedTime]';
        dspx.config.creative.expandedCreativeWidth = '[user_expandedCreativeWidth]';
        dspx.config.creative.expandedCreativeHeight = '[user_expandedCreativeHeight]';
        dspx.config.creative.clickURLExpanded = ['[EXPAND_CLICK_URL]'];
        dspx.config.creative.expandTracking = [user_expandTrackings];

        dspx.config.creative.backup= dspx.config.creative.backup || {};
        dspx.config.creative.backup.id= dspx.config.creative.backup.id || Number();
        dspx.config.creative.backup.url= dspx.config.creative.backup.url || '';
        dspx.config.creative.backup.clickUrl= dspx.config.creative.backup.clickUrl || '';
        dspx.config.creative.backup.clickTarget= dspx.config.creative.backup.clickTarget || '';
        dspx.config.creative.backup.width= dspx.config.creative.backup.width || Number();
        dspx.config.creative.backup.height= dspx.config.creative.backup.height || Number();

        dspx.config.other= dspx.config.other||{};
        dspx.config.other.maxWidth= '[user_maxWidth]';
        dspx.config.other.height= dspx.config.other.height||'100%';
        dspx.config.other.marginTop= dspx.config.other.marginTop||0;
        dspx.config.other.onLoadEvent= dspx.config.other.onLoadEvent||false;
        dspx.config.trackingUrls= [THIRDPARTY_TRACKINGS].concat(["[IMPRESSION_URL]"]);
        dspx.config.other.horizontalPosition= dspx.config.other.horizontalPosition||'center';

        dspx.config.border= dspx.config.border||{};
        dspx.config.border.borderHeight= [user_borderHeight];
        dspx.config.border.backgroundColorBorder= '[user_backgroundColorBorder]';

        dspx.config.willShowCountDownCloseButton = '[user_showCloseCounter]';
        dspx.config.closeCunter = [user_closeCounter];
        dspx.config.closeActionTime = [user_closeActionTime];

        dspx.config.textLabel= dspx.config.textLabel||{};
        dspx.config.textLabel.text= '[user_textLabelText]';
        dspx.config.textLabel.fontSize= [user_fontSize];
        dspx.config.textLabel.backgroundColor= '[user_backgroundColor]';
        dspx.config.textLabel.color= '[user_textLabelColor]';

        dspx.config.placeOfAd= dspx.config.placeOfAd||{};
        dspx.config.placeOfAd.automaticPosition= dspx.config.placeOfAd.automaticPosition||false;
        dspx.config.placeOfAd.place= dspx.config.placeOfAd.place||'Smart tag';
        dspx.config.placeOfAd.elementName= dspx.config.placeOfAd.elementName||'';
        dspx.config.placeOfAd.paragraphType= dspx.config.placeOfAd.paragraphType||'p';

        dspx.config.viewability= dspx.config.viewability||{};
        dspx.config.viewability.automaticPosition= dspx.config.viewability.automaticPosition||'';
        dspx.config.viewability.place= dspx.config.viewability.place||'';
        
        dspx.config.tagId= ("[INJTAGID]" == "") ? null : "[INJTAGID]"; 
        dspx.config.insertionCustomHtml="[user_insertionCustomHtml]";
        dspx.config.inventory_types=[INVENTORY_TYPES];
        
    }(dspx))
}catch(e){console.error("dspxDefaults:"+e.message);};

var script = document.createElement('script');
script.src = 'https://xtag.cdn-solution.net/ms/sitebar/dspx/sitebar.min.js';
script.async = false;
document.head.appendChild(script);
`;
                    return InscreenCommonService.replaceCommonPlaceholders(scope, template, options);
                };





        },
    ]);
})(window.angular);
